import { z } from 'zod';
import { MOVE_SLOTS } from '../../../types';
import { effectAtomIdSchema } from '../atoms';
import { pokemonTypeSchema } from './pokemon';

const moveSlotSchema = z.enum(MOVE_SLOTS);

const moveEffectEntrySchema = z.object({
  atom: effectAtomIdSchema,
  // TODO(0.5b): narrow `params` per effect atom (discriminated union / per-atom schemas).
  params: z.record(z.unknown()),
});

export const moveDataSchema = z.object({
  dataVersion: z.number().int().positive(),
  id: z.string().min(1),
  slot: moveSlotSchema,
  type: pokemonTypeSchema,
  category: z.enum(['physical', 'special', 'status']),
  baseCD: z.number().positive(),
  power: z.number().nonnegative(),
  accuracy: z.number().min(0).max(100),
  effects: z.array(moveEffectEntrySchema),
});

export type MoveData = z.infer<typeof moveDataSchema>;
